export default function userState(
  state = { displayName: '', email: '', photoURL: '' },
  action,
) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js